import {
  FiAlertCircle
} from "react-icons/fi";

export default function WeddingServices() {
  const services = [
    {
      title: "Guest & Room Planning",
      icon: "/images/guest-icon.svg",
      features: ["Family-wise mapping, VIP tagging, Welcome kits."],
    },
    {
      title: "Stay Quality Control",
      icon: "/images/quality-icon.png",
      features: ["Linen checks, bathroom inspection, AC & water testing."],
    },
    {
      title: "Transport Management",
      icon: "/images/transport-icon.png",
      features: ["Pickups, shuttles, backups, driver control."],
    },
    {
      title: "24/7 Guest Support",
      icon: "/images/24-icon.png",
      features: ["Dedicated counter, complaint handling, quick resolution."],
    },
    {
      title: "VIP & Elder Care",
      // icon: <FiHeart size={54} />,
      icon: "/images/vip-icon.png",
      features: ["Priority rooms, escorts, medical support."],
    },
    {
      title: "Emergency Readiness",
      icon: "/images/emergency-icon.png",
      features: ["Backup rooms, vehicles, vendors"],
    },
  ];

  return (
    <section className="py-12 bg-white">
      <div className="max-w-[1360px] mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-serif text-[#b76d68]">
            Wedding Stay Services
          </h2>
          <p className="text-gray-600 mt-3 font-outfit">
            Complete hospitality & wedding operations support
          </p>
          {/* Decorative Divider */}
          <div className="flex justify-center items-center gap-3 mt-6">
            <div className="w-10 h-[1px] bg-red-300"></div>
            <div className="w-2 h-2 bg-red-400 rounded-full"></div>
            <div className="w-10 h-[1px] bg-red-300"></div>
          </div>
        </div>

        {/* 🔥 6 Cards Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 text-center lg:grid-cols-6 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#3e1c1c] cursor-pointer text-white p-4 rounded-2xl shadow-2xl
                         flex flex-col min-h-[240px] 
                         transition hover:-translate-y-2 hover:shadow-3xl  duration-300"
            >
              {/* Icon */}
              <div className="flex justify-center mb-5">
                <div
                  className="w-28 h-28 flex items-center justify-center 
                                transition hover:scale-110 duration-300"
                >
                  <img
                    src={service.icon}
                    alt={service.title}
                    className="w-28 h-28 object-contain"
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-sm font-playfair font-medium text-center mb-2 text-gold-gradient">
                {service.title}
              </h3>

              <ul className="space-y-2 text-xs font-playfair flex-grow text-center">
                {service.features.map((feature, i) => (
                  <li
                    key={i}
                    className="flex justify-center items-center "
                  >
                    <span >{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
